import { FC } from "react";
import { Routes, Route } from "react-router-dom";

import AnnuityCalculatorPage from "./pages/AnnuityCalculatorPage";
import SavingsProjectionCalculatorPage from "./pages/SavingsProjectionCalculatorPage";
import SavingsGoalCalculatorPage from "./pages/SavingsGoalCalculatorPage";

const App: FC = () => (
  <Routes>
    <Route path="/" element={<AnnuityCalculatorPage />} />
    <Route path="/annuity" element={<AnnuityCalculatorPage />} />
    <Route path="/savings" element={<SavingsProjectionCalculatorPage />} />
    <Route
      path="/savings-projection"
      element={<SavingsProjectionCalculatorPage />}
    />
    <Route path="/savings-goal" element={<SavingsGoalCalculatorPage />} />
  </Routes>
);

export default App;
